import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ProductCard } from '@/components/ProductCard';
export function CatalogProductGrid({ products, productsLoading, productsError, getCartQuantity, isProductAvailable, onSelectProduct, onAddToCart, onIncrement, onDecrement, }) {
    if (productsError) {
        return _jsx("p", { className: "catalog__message catalog__message--error", children: productsError });
    }
    if (productsLoading) {
        return _jsx("p", { className: "catalog__message", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0442\u043E\u0432\u0430\u0440\u043E\u0432\u2026" });
    }
    return (_jsx(_Fragment, { children: products.map((product) => (_jsx(ProductCard, { product: product, cartQuantity: getCartQuantity(product.id), onCardClick: onSelectProduct, onAddToCart: () => onAddToCart(product), onIncrement: () => onIncrement(product.id), onDecrement: () => onDecrement(product.id), unavailable: !isProductAvailable(product) }, product.id))) }));
}
